export const userConstants = {
  SHARE_OVER_EMAIL_REQUEST: "SHARE_OVER_EMAIL_REQUEST",
  SHARE_OVER_EMAIL_SUCCESS: "SHARE_OVER_EMAIL_SUCCESS",
  SHARE_OVER_EMAIL_FAILURE: "SHARE_OVER_EMAIL_FAILURE",

  REGISTER_REQUEST: "USERS_REGISTER_REQUEST",
  REGISTER_SUCCESS: "USERS_REGISTER_SUCCESS",
  REGISTER_FAILURE: "USERS_REGISTER_FAILURE",

  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",

  LOGOUT: "USERS_LOGOUT",

  GETALL_REQUEST: "USERS_GETALL_REQUEST",
  GETALL_SUCCESS: "USERS_GETALL_SUCCESS",
  GETALL_FAILURE: "USERS_GETALL_FAILURE",

  GET_ALL_USERS_IMPERSONATION_REQUEST:"GET_ALL_USERS_IMPERSONATION_REQUEST",
  GET_ALL_USERS_IMPERSONATION_SUCCESS:"GET_ALL_USERS_IMPERSONATION_SUCCESS",
  GET_ALL_USERS_IMPERSONATION_FAILURE:"GET_ALL_USERS_IMPERSONATION_FAILURE",

  CREATE_MPIN_REQUEST: "CREATE_MPIN_REQUEST",
  CREATE_MPIN_SUCCESS: "CREATE_MPIN_SUCCESS",
  CREATE_MPIN_FAILURE: "CREATE_MPIN_FAILURE",

  GETUSER_REQUEST: "USER_GET_REQUEST",
  GETUSER_SUCCESS: "USER_GET_SUCCESS",
  GETUSER_FAILURE: "USER_GET_FAILURE",

  USER_FETCH_FILTER_REQUEST: "USER_FETCH_FILTER_REQUEST",
  USER_FETCH_FILTER_SUCCESS: "USER_FETCH_FILTER_SUCCESS",
  USER_FETCH_FILTER_FAILURE: "USER_FETCH_FILTER_FAILURE",

  GET_USER_TOP_CARD_INFO_REQUEST: "GET_USER_TOP_CARD_INFO_REQUEST",
  GET_USER_TOP_CARD_INFO_SUCCESS: "GET_USER_TOP_CARD_INFO_SUCCESS",
  GET_USER_TOP_CARD_INFO_FAILURE: "GET_USER_TOP_CARD_INFO_FAILURE",

  UPDATE_USER_DETAILS_REQUEST: "UPDATE_USER_DETAILS_REQUEST",
  UPDATE_USER_DETAILS_SUCCESS: "UPDATE_USER_DETAILS_SUCCESS",
  UPDATE_USER_DETAILS_FAILURE: "UPDATE_USER_DETAILS_FAILURE",

  DELETE_REQUEST: "USERS_DELETE_REQUEST",
  DELETE_SUCCESS: "USERS_DELETE_SUCCESS",
  DELETE_FAILURE: "USERS_DELETE_FAILURE",

  PASSWORD_RESET_REQUEST: "PASSWORD_RESET_REQUEST",
  PASSWORD_RESET_SUCCESS: "PASSWORD_RESET_SUCCESS",
  PASSWORD_RESET_FAILURE: "PASSWORD_RESET_FAILURE",

  VERIFY_TOKEN_REQUEST: "VERIFY_TOKEN_REQUEST",
  VERIFY_TOKEN_SUCCESS: "VERIFY_TOKEN_SUCCESS",
  VERIFY_TOKEN_FAILURE: "VERIFY_TOKEN_FAILURE",

  VERIFY_DEFAULT_TOKEN_REQUEST: "DEFAULT_TOKEN_VERIFY_REQUEST",
  VERIFY_DEFAULT_TOKEN_SUCCESS: "DEFAULT_TOKEN_VERIFY_SUCCESS",
  VERIFY_DEFAULT_TOKEN_FAILURE: "DEFAULT_TOKEN_VERIFY_FAILURE",

  PASSWORD_CHANGE_REQUEST: "PASSWORD_CHANGE_REQUEST",
  PASSWORD_CHANGE_SUCCESS: "PASSWORD_CHANGE_SUCCESS",
  PASSWORD_CHANGE_FAILURE: "PASSWORD_CHANGE_FAILURE",

  PASSWORD_CREATE_REQUEST: "CREATE_PASSWORD_REQUEST",
  PASSWORD_CREATE_SUCCESS: "CREATE_PASSWORD_SUCCESS",
  PASSWORD_CREATE_FAILURE: "CREATE_PASSWORD_FAILURE",

  UPDATE_PROFILE_REQUEST: "PROFILE_UPDATE_REQUEST",
  UPDATE_PROFILE_SUCCESS: "PROFILE_UPDATE_SUCCESS",
  UPDATE_PROFILE_FAILURE: "PROFILE_UPDATE_FAILURE",

  PASSWORD_UPDATE_REQUEST: "PASSWORD_UPDATE_REQUEST",
  PASSWORD_UPDATE_SUCCESS: "PASSWORD_UPDATE_SUCCESS",
  PASSWORD_UPDATE_FAILURE: "PASSWORD_UPDATE_FAILURE",

  GET_ALL_NOTIFICATIONS_REQUEST: "ALL_NOTIFICATIONS_GET_REQUEST",
  GET_ALL_NOTIFICATIONS_SUCCESS: "ALL_NOTIFICATIONS_GET_SUCCESS",
  GET_ALL_NOTIFICATIONS_FAILURE: "ALL_NOTIFICATIONS_GET_FAILURE",

  GET_ALL_LOGIN_DETAILS_REQUEST: "ALL_LOGIN_DETAILS_GET_REQUEST",
  GET_ALL_LOGIN_DETAILS_SUCCESS: "ALL_LOGIN_DETAILS_GET_SUCCESS",
  GET_ALL_LOGIN_DETAILS_FAILURE: "ALL_LOGIN_DETAILS_GET_FAILURE",

  GET_ALL_LOGIN_DETAILS_TOP_CARDS_REQUEST: "ALL_LOGIN_DETAILS_GET_TOP_CARDS_REQUEST",
  GET_ALL_LOGIN_DETAILS_TOP_CARDS_SUCCESS: "ALL_LOGIN_DETAILS_GET_TOP_CARDS_SUCCESS",
  GET_ALL_LOGIN_DETAILS_TOP_CARDS_FAILURE: "ALL_LOGIN_DETAILS_GET_TOP_CARDS_FAILURE",

  
  GET_ALL_USER_SESSION_FILTERS_REQUEST: "GET_ALL_USER_SESSION_FILTERS_REQUEST",
  GET_ALL_USER_SESSION_FILTERS_SUCCESS: "GET_ALL_USER_SESSION_FILTERS_SUCCESS",
  GET_ALL_USER_SESSION_FILTERS_FAILURE: "GET_ALL_USER_SESSION_FILTERS_FAILURE",

  UPDATE_ALL_NOTIFICATIONS_REQUEST: "ALL_NOTIFICATIONS_UPDATE_REQUEST",
  UPDATE_ALL_NOTIFICATIONS_SUCCESS: "ALL_NOTIFICATIONS_UPDATE_SUCCESS",
  UPDATE_ALL_NOTIFICATIONS_FAILURE: "ALL_NOTIFICATIONS_UPDATE_FAILURE",

  GET_ALL_ACCESS_CONTROL_REQUEST: "GET_ALL_ACCESS_CONTROL_REQUEST",
  GET_ALL_ACCESS_CONTROL_SUCCESS: "GET_ALL_ACCESS_CONTROL_SUCCESS",
  GET_ALL_ACCESS_CONTROL_FAILURE: "GET_ALL_ACCESS_CONTROL_FAILURE",

  GET_USERS_ACCESS_CONTROL_REQUEST: "GET_USERS_ACCESS_CONTROL_REQUEST",
  GET_USERS_ACCESS_CONTROL_SUCCESS: "GET_USERS_ACCESS_CONTROL_SUCCESS",
  GET_USERS_ACCESS_CONTROL_FAILURE: "GET_USERS_ACCESS_CONTROL_FAILURE",

  POST_USERS_ACCESS_CONTROL_REQUEST: "POST_USERS_ACCESS_CONTROL_REQUEST",
  POST_USERS_ACCESS_CONTROL_SUCCESS: "POST_USERS_ACCESS_CONTROL_SUCCESS",
  POST_USERS_ACCESS_CONTROL_FAILURE: "POST_USERS_ACCESS_CONTROL_FAILURE",

  USERS_ACCESS_CONTROL_REQUEST: "USERS_ACCESS_CONTROL_REQUEST",
  USERS_ACCESS_CONTROL_SUCCESS: "USERS_ACCESS_CONTROL_SUCCESS",
  USERS_ACCESS_CONTROL_FAILURE: "USERS_ACCESS_CONTROL_FAILURE",

  GET_SESSION_INFO_REQUEST: "GET_SESSION_INFO_REQUEST",
  GET_SESSION_INFO_SUCCESS: "GET_SESSION_INFO_SUCCESS",
  GET_SESSION_INFO_FAILURE: "GET_SESSION_INFO_FAILURE",

  ONBOARD_USER_REQUEST: "ONBOARD_USER_REQUEST",
  ONBOARD_USER_SUCCESS: "ONBOARD_USER_SUCCESS",
  ONBOARD_USER_FAILURE: "ONBOARD_USER_FAILURE",

  GET_CUSTOMER_DETAILS_REQUEST: "GET_CUSTOMER_DETAILS_REQUEST",
  GET_CUSTOMER_DETAILS_SUCCESS: "GET_CUSTOMER_DETAILS_SUCCESS",
  GET_CUSTOMER_DETAILS_FAILURE: "GET_CUSTOMER_DETAILS_FAILURE",

  APPLY_FILTER_LIST_REQUEST: "APPLY_FILTER_LIST_REQUEST",
  APPLY_FILTER_LIST_SUCCESS: "APPLY_FILTER_LIST_SUCCESS",
  APPLY_FILTER_LIST_FAILURE: "APPLY_FILTER_LIST_FAILURE",

  GET_NOTIFICATION_COUNT_REQUEST: "GET_NOTIFICATION_COUNT_REQUEST",
  GET_NOTIFICATION_COUNT_SUCCESS: "GET_NOTIFICATION_COUNT_SUCCESS",
  GET_NOTIFICATION_COUNT_FAILURE: "GET_NOTIFICATION_COUNT_FAILURE",

  GET_ALL_CARDS_REQUEST: "GET_ALL_CARDS_REQUEST",
  GET_ALL_CARDS_SUCCESS: "GET_ALL_CARDS__SUCCESS",
  GET_ALL_CARDS_FAILURE: "GET_ALL_CARDS__FAILURE",

  CHECK_DUPLICATE_USERNAME_REQUEST: "CHECK_DUPLICATE_USERNAME_REQUEST",
  CHECK_DUPLICATE_USERNAME_SUCCESS: "CHECK_DUPLICATE_USERNAME_SUCCESS",
  CHECK_DUPLICATE_USERNAME_FAILURE: "CHECK_DUPLICATE_USERNAME_FAILURE",

  USER_LOGOUT_BY_TOKEN_REQUEST: "USER_LOGOUT_BY_TOKEN_REQUEST",
  USER_LOGOUT_BY_TOKEN_SUCCESS: "USER_LOGOUT_BY_TOKEN_SUCCESS",
  USER_LOGOUT_BY_TOKEN_FAILURE: "USER_LOGOUT_BY_TOKEN_FAILURE",

  VERIFY_SUBSCRIPTION_REQUEST: "CLOSE_ACCOUNT_REQUEST",
  VERIFY_SUBSCRIPTION_SUCCESS: "CLOSE_ACCOUNT_SUCCESS",
  VERIFY_SUBSCRIPTION_FAILURE: "CLOSE_ACCOUNT_FAILURE",

  RESEND_VERIFY_REQUEST: "RESEND_VERIFY_REQUEST",
  RESEND_VERIFY_SUCCESS: "RESEND_VERIFY_SUCCESS",
  RESEND_VERIFY_FAILURE: "RESEND_VERIFY_FAILURE",

  USER_IMPERSONATE_REQUEST: "USER_IMPERSONATE_REQUEST",
  USER_IMPERSONATE_SUCCESS: "USER_IMPERSONATE_SUCCESS",
  USER_IMPERSONATE_FAILURE: "USER_IMPERSONATE_FAILURE",

  AINOTIFICATION_UPDATE_REQUEST: "AINOTIFICATION_UPDATE_REQUEST",
  AINOTIFICATION_UPDATE_SUCCESS: "AINOTIFICATION_UPDATE_SUCCESS",
  AINOTIFICATION_UPDATE_FAILURE: "AINOTIFICATION_UPDATE_FAILURE",

  GET_ALL_ACTIVE_USERS_REQUEST: "GET_ALL_ACTIVE_USERS_REQUEST",
  GET_ALL_ACTIVE_USERS_SUCCESS: "GET_ALL_ACTIVE_USERS_SUCCESS",
  GET_ALL_ACTIVE_USERS_FAILURE: "GET_ALL_ACTIVE_USERS_FAILURE",

  UPDATE_IS_NEW_NOTIFICATION_COUNT_REQUEST: "UPDATE_IS_NEW_NOTIFICATION_COUNT_REQUEST",
  UPDATE_IS_NEW_NOTIFICATION_COUNT_SUCCESS: "UPDATE_IS_NEW_NOTIFICATION_COUNT_SUCCESS",
  UPDATE_IS_NEW_NOTIFICATION_COUNT_FAILURE: "UPDATE_IS_NEW_NOTIFICATION_COUNT_FAILURE",

  GET_NOTIFICATION_REQUEST: "GET_NOTIFICATION_REQUEST",
  GET_NOTIFICATION_SUCCESS: "GET_NOTIFICATION_SUCCESS",
  GET_NOTIFICATION_FAILURE: "GET_NOTIFICATION_FAILURE",

  FETCH_NOTIFICATION_OPTIONS_REQUEST: "FETCH_NOTIFICATION_OPTIONS_REQUEST",
  FETCH_NOTIFICATION_OPTIONS_SUCCESS: "FETCH_NOTIFICATION_OPTIONS_SUCCESS",
  FETCH_NOTIFICATION_OPTIONS_FAILURE: "FETCH_NOTIFICATION_OPTIONS_FAILURE",
  
  REGISTER_COMPANY_REQUEST: "REGISTER_COMPANY_REQUEST",
  REGISTER_COMPANY_SUCCESS: "REGISTER_COMPANY_SUCCESS",
  REGISTER_COMPANY_FAILURE: "REGISTER_COMPANY_FAILURE",

  CHECK_DOMAIN_AVAILABILITY_REQUEST: "CHECK_DOMAIN_AVAILABILITY_REQUEST",
  CHECK_DOMAIN_AVAILABILITY_SUCCESS: "CHECK_DOMAIN_AVAILABILITY_SUCCESS",
  CHECK_DOMAIN_AVAILABILITY_FAILURE: "CHECK_DOMAIN_AVAILABILITY_FAILURE",

  GENERATE_EMAIL_OTP_REQUEST: "GENERATE_EMAIL_OTP_REQUEST",
  GENERATE_EMAIL_OTP_SUCCESS: "GENERATE_EMAIL_OTP_SUCCESS",
  GENERATE_EMAIL_OTP_FAILURE: "GENERATE_EMAIL_OTP_FAILURE",

  VERIFY_EMAIL_OTP_REQUEST: "VERIFY_EMAIL_OTP_REQUEST", 
  VERIFY_EMAIL_OTP_SUCCESS: "VERIFY_EMAIL_OTP_SUCCESS",
  VERIFY_EMAIL_OTP_FAILURE: "VERIFY_EMAIL_OTP_FAILURE",

  RESEND_EMAIL_OTP_REQUEST: "RESEND_EMAIL_OTP_REQUEST",
  RESEND_EMAIL_OTP_SUCCESS: "RESEND_EMAIL_OTP_SUCCESS",
  RESEND_EMAIL_OTP_FAILURE: "RESEND_EMAIL_OTP_FAILURE"
};
